import { View, Text, ScrollView, Pressable, ImageBackground } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import { useNavigation } from '@react-navigation/native';
import { Row, Table } from 'react-native-table-component';
import heatmap from '../heatmap';
import GlobalStyles from './../style';
import cupsData from '../cupsData';
import AsyncStorage from '@react-native-async-storage/async-storage';
import alert from './../alert';
import { useSelector } from 'react-redux'
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'

let lang = undefined;

const FriendProfile = ({route}) => {
    const friendTeam = route.params.team
    const navigation = useNavigation();

    useLayoutEffect(() => {
        navigation.setOptions({
            headerTitle: transl('MainMenu.perfilAmigo', lang)
        })
    }, []);

    //receivedData
    const [value, setvalue] = useState('');
    const readValue = ({uuid}) => {
        AsyncStorage.getItem('equipos')
        .then((value)=> {
            finallyDelete(value,uuid)
        })
    }
    const storeData = async (value) => {
        try {
          const jsonValue = JSON.stringify(value)
          await AsyncStorage.setItem('equipos', jsonValue)
        } catch (e) {
          console.log("error saving file")
          console.log(e)
        }
    }

    lang = dr.idiomas[useSelector((state) => state.language)].value

    let state = {
        tableHead: [transl('Roster.posicion',lang), transl('Roster.nombre',lang), transl('Roster.precision',lang), transl('Roster.reflejos',lang), transl('Roster.manejo',lang), transl('Roster.fuerza',lang), transl('Roster.resistencia',lang), transl('Roster.velocidad',lang), transl('Roster.maniobra',lang), transl('Roster.estabilidad',lang),transl('Statistics.edad',lang)],
        widthArr: [90, 130, 70, 70, 70, 70, 70, 70, 70, 70, 70]
    }

    return (
        <View style={{flex:1}}>
            <ImageBackground source={require('./../img/background5.png')} resizeMode="cover" style={{flex:1}}>
                <ScrollView>
                    {printTeamInfo(friendTeam)}
                </ScrollView>
            </ImageBackground>
        </View>
    )


    function printTeamInfo(team) {
        const styles = {
            container: { flex: 1, padding: 16, paddingTop: 30, backgroundColor: '#fff' },
            header: { height: 50, backgroundColor: '#f2f2f2' },
            text: { textAlign: 'center', fontWeight: 'bold', fontSize:13 },
            row: { height: 40, backgroundColor: '#E7E6E1' }
        };
        let players = [];
        for(let i = 0; i < team.players.length; i++){
            let thisPlayer = [];
            if(i==0)thisPlayer.push(<Text style={{textAlign:'center'}}>{transl('Roster.guardian',lang)}</Text>)
            else if(i==1 || i==2)thisPlayer.push(<Text style={{textAlign:'center'}}>{transl('Roster.golpeador',lang)}</Text>)
            else if(i==3 || i==4)thisPlayer.push(<Text style={{textAlign:'center'}}>{transl('Roster.cazador',lang)}</Text>)
            else if(i==5)thisPlayer.push(<Text style={{textAlign:'center'}}>{transl('Roster.cazadorDelantero',lang)}</Text>)
            else if(i==6)thisPlayer.push(<Text style={{textAlign:'center'}}>{transl('Roster.buscador',lang)}</Text>)
            thisPlayer.push(<Text style={{textAlign:'center'}}>{team.players[i].name}</Text>)

            thisPlayer.push(heatmap(team.players[i].skills[0]))
            thisPlayer.push(heatmap(team.players[i].skills[1]))
            thisPlayer.push(heatmap(team.players[i].skills[2]))
            thisPlayer.push(heatmap(team.players[i].skills[3]))
            thisPlayer.push(heatmap(team.players[i].skills[4]))

            thisPlayer.push(heatmap(team.players[i].broom[0]))
            thisPlayer.push(heatmap(team.players[i].broom[1]))
            thisPlayer.push(heatmap(team.players[i].broom[2]))

            thisPlayer.push(<Text style={{textAlign:'center'}}>{team.players[i].age}</Text>)

            let rowElement = <Row
                key={i}
                data={thisPlayer}
                widthArr={state.widthArr}
                textStyle={{textAlign:'center'}}
                style={
                    [i%2 && {backgroundColor: '#ffffff'},
                    i==0 && {backgroundColor: '#ffffb3'},
                    (i==1 || i==2) && {backgroundColor: '#b3ffff'},
                    (i==3 || i==4) && {backgroundColor: '#ffb3ff'},
                    i==5 && {backgroundColor: '#ff80ff'},
                    i==6 && {backgroundColor: '#ffff66'},
                    {paddingVertical:4}]
                }
            />

            players.push(rowElement)
        }

        const myTable = <ScrollView horizontal={true}>
            <View style={{marginTop:50}}>
                <Table borderStyle={{borderWidth: 1, borderColor: '#C1C0B9'}}>
                    <Row data={state.tableHead} widthArr={state.widthArr} style={styles.header} textStyle={styles.text}/>
                </Table>
                <Table>{players}</Table>
            </View>
            </ScrollView>
            

        if(myTable == undefined) return <Text>{transl('General.cargando',lang)}</Text>

        let allTrophies = [];
        let trophies = team.info.trophies
        for(let i = 0; i < trophies.length; i++){
            allTrophies.push(cupsData(trophies[i].cupType ? trophies[i].cupType : [trophies[i].name,trophies[i].description],trophies[i].icon,trophies[i].season,trophies[i].date ? trophies[i].date : 0, lang, (trophies[i].player && trophies[i].age) ? [trophies[i].player,trophies[i].age] : []))
        }

        if(allTrophies.length==0){
            allTrophies.push(<View style={{marginLeft:'auto',marginRight:'auto',paddingHorizontal:50}}><Text style={{fontSize:18,textAlign:'justify'}}>{transl('FriendProfile.esteAmigoNoTiene', lang)}</Text></View>)
        } else allTrophies = allTrophies.reverse()

        return <View style={{marginTop:25}}>
            <Text style={stylesTexts}>{transl('FriendsList.nombre', lang, [team.info.name])}</Text>
            <Text style={stylesTexts}>{transl('FriendsList.equipo', lang, [team.info.teamName])}</Text>
            <Text style={stylesTexts}>{transl('FriendsList.añadido', lang, [new Date(team.info.date).getDate(),new Date(team.info.date).getMonth()+1,new Date(team.info.date).getFullYear()])}</Text>
            {myTable}
            <View style={{marginLeft: 'auto', marginRight: 'auto', marginTop:50}}>
                <Pressable
                    style={GlobalStyles.buttonMain}
                    onPress={() => {navigation.navigate('NextMatch',{name:'multijugador',teamUuid:friendTeam.info.uuid})}}>
                    <Text style={GlobalStyles.textForButtonMain}>{transl('FriendProfile.jugarAmistoso', lang)}</Text>
                </Pressable>
            </View>
            <View style={{marginTop:40}}>
                <Text style={stylesTexts}>{transl('FriendProfile.trofeos', lang)}</Text>
                {allTrophies}
            </View>
            <View style={{marginLeft: 'auto', marginRight: 'auto', marginTop:50, marginBottom:50}}>
                <Pressable
                    style={GlobalStyles.buttonDelete}
                    onPress={() => {reallyDelete(team.info.uuid,navigation,team.info.name)}}>
                    <Text style={GlobalStyles.textForButtonMain}>{transl('FriendProfile.eliminarAmigo', lang)}</Text>
                </Pressable>
            </View>
        </View>
    }

    function reallyDelete(uuid,navigation,name){
        alert(transl('General.warning', lang),transl('FriendProfile.seEliminaraDeTu', lang, [name]),[
            {text: transl('General.cancelar', lang), onPress: () => void(0), style: "cancel"},
            {text: transl('General.OK', lang), onPress: () => {deleteFriend(uuid,navigation)}}
        ])
    }
    function deleteFriend(uuid,navigation){
        readValue({uuid});
        alert(transl('General.eliminado', lang),transl('FriendProfile.amigoEliminado', lang),[
            {text: transl('General.OK', lang),onPress: () => void(0),style: "cancel"}
        ])
        navigation.navigate('HomeScreen')
    }
    function finallyDelete(value,uuid){
        if(value === undefined || !value) return
        if(typeof value != "object") value = value != null ? JSON.parse(value) : null
        value.multiplayer.teams = value.multiplayer.teams.filter((team) => team.info.uuid != uuid);
        storeData(value)
    }
}

const stylesTexts = {
    textAlign: 'center',
    marginBottom:10,
    fontSize:24
}

export default FriendProfile